
    <div class="overlay" *ngIf="spinnerService.displaySpinner || spinnerService.displaySpinnerNonHttpCalls">
      <div class="spinner"></div>
    </div>
  